import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';

export interface GenericReadArticle {
  faqId: string;
  labelProvider?: labelProviderInterface;
}


export const GenericReadArticle: FunctionalComponent<GenericReadArticle> = (props) => {

    const { faqId, labelProvider } = props;

    return (faqId ?
      <section class={'video-card__read-article'}>
        <qds-standalone-link class={'video-card__read-article_container'} href={faqId} importance={'emphasized'}>
          <span class={'video-card__read-article_text'}>
            {labelProvider('read-article', 'Read article')}
          </span>
        </qds-standalone-link>
      </section> : ''
    );

};
